module.exports = __webpack_public_path__ + "static/media/header.a94b326e.gif";